// Type definition for runtime config loaded from env-config.js
interface RuntimeConfig {
  API_URL?: string;
}

// Declare the global window property
declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

// Runtime config (z env-config.js v kontejneru) nebo fallback na build-time
const runtimeConfig: RuntimeConfig | undefined = window.__RUNTIME_CONFIG__;

export const NODE_ENV = process.env.NODE_ENV;

// Get API URL with fallback chain: runtime config -> env variable -> undefined
const getApiUrl = (): string | undefined => {
  if (runtimeConfig?.API_URL && runtimeConfig.API_URL !== "__API_URL__") {
    return runtimeConfig.API_URL;
  }
  return process.env.REACT_APP_API_URL;
};

export const API_SERVER_URL = getApiUrl();